import { FieldProps } from "formik";
import React from "react";
import MaskedInput, { MaskedInputProps } from "react-text-mask";

export interface MaskedTextInputProps extends MaskedInputProps {
	field?: FieldProps["field"];
	id: string;
	name: string;
	onKeyPress?: (e: React.KeyboardEvent) => void;
	ref?: React.RefObject<any>;
	value?: string;
	[key: string]: any;
	editInline?: boolean;
	className?: string;
}

const MaskedTextInput: React.FC<MaskedTextInputProps> = ({
	type = "text",
	field,
	className,
	editInline,
	name,
	id,
	innerRef,
	...props
}) => {
	return (
		<MaskedInput
			id={id}
			{...field}
			name={(field && field.name) || name}
			value={field?.value === 0
					? 0
					: (field && field.value) || props.value}
			className={`${className ? className : ""}${editInline ? "edit-inline" : ""}`}
			{...props}
		/>
	);
};

export default MaskedTextInput;
